function ConsultantSettings() {
  return <div>Consultant Settings</div>;
}

export default ConsultantSettings;
